import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid } from '@mui/material';
// components

// sections
import {
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title> Dashboard | Elevate Land Surveying </title>
      </Helmet>

      <Grid container spacing={3} sx={{ p: 4, pb: 0 }}>
        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Clients" total={1250} icon={'ant-design:user-outlined'} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Active Jobs" total={50} color="info" icon={'ant-design:schedule-outlined'} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Revenue" total={60000} color="warning" icon={'ant-design:rise-outlined'} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Expenses" total={15000} color="error" icon={'ant-design:fall-outlined'} />
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <AppWebsiteVisits
            title="Active Jobs"
            chartLabels={[
              '01/02/2022',
              '02/02/2022',
              '03/02/2022',
              '04/02/2022',
              '05/02/2022',
              '06/02/2022',
              '07/02/2022',
              '08/02/2022',
              '09/02/2022',
              '10/02/2022',
              '11/02/2022',
              '12/02/2022',
            ]}
            chartData={[
              {
                name: 'Active Jobs',
                type: 'column',
                fill: 'solid',
                data: [5, 10, 7, 9, 12, 15, 14, 10, 4, 18, 15],
              },
            ]}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <AppCurrentVisits
            title="Financial Data"
            chartData={[
              { label: 'Expense', value: 15000 },
              { label: 'Revenue', value: 60000 },
            ]}
            chartColors={[theme.palette.primary.main, theme.palette.info.main]}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <AppCurrentSubject
            title="Current Subject"
            chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
            chartData={[
              { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
              { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
              { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
            ]}
            chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <AppConversionRates
            title="Conversion Rates"
            subheader="(+43%) than last year"
            chartData={[
              { label: 'Italy', value: 400 },
              { label: 'Japan', value: 430 },
              { label: 'China', value: 448 },
              { label: 'Canada', value: 470 },
              { label: 'France', value: 540 },
              { label: 'Germany', value: 580 },
              { label: 'South Korea', value: 690 },
              { label: 'Netherlands', value: 1100 },
              { label: 'United States', value: 1200 },
              { label: 'United Kingdom', value: 1380 },
            ]}
          />
        </Grid>
      </Grid>
    </>
  );
}
